import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function Check(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </SvgIcon>
  );
}

export default React.memo(Check);



// WEBPACK FOOTER //
// ./src/icons/internals/Check.jsx